export const UKRAINE_COUNTRY_CODE = 'UA';
export const UKRAINE_COUNTRY_NAME = 'Ukraine';
